/**
 * Global API Configuration
 * 
 * Reads from environment variables (REACT_APP_*) set via .env files.
 * - .env.development  → npm start (localhost)
 * - .env.production   → npm run build (production)
 */

const CONFIG = {
    authApi: process.env.REACT_APP_AUTH_API || "http://localhost:5001/api/v1",
    helperApi: process.env.REACT_APP_HELPER_API || "http://localhost:5049/api/v1",
};

export default CONFIG;
